var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Button, ChevronDownIcon, DropdownMenu, DropdownMenuList, DropdownMenuListItem, styled, useDropdownMenuState, } from '@auth0/quantum-product';
import { connectToStores } from 'fluxible-addons-react';
import * as React from 'react';
import DocumentStore from '../../../../stores/DocumentStore';
import QuickstartStore from '../../../../stores/QuickstartStore';
import canUseStore from '../../../../util/canUseStore';
var StepNumber = styled('div')(function (_a) {
    var theme = _a.theme;
    return ({
        background: theme.palette.primary.main,
        borderRadius: '50%',
        width: '24px',
        height: '24px',
        display: 'inline-block',
        color: '#fff',
        textAlign: 'center',
        fontSize: '16px',
        lineHeight: '24px',
        position: 'relative',
        marginRight: theme.spacing(2),
    });
});
var StepContent = styled('div')(function () { return ({
    display: 'inline-block',
    fontSize: '28px',
}); });
var StyledH2 = styled('h2')(function (_a) {
    var theme = _a.theme;
    return ({
        margin: theme.spacing(2, 0),
        display: 'flex',
        alignItems: 'center',
    });
});
var StyledH2DropDown = styled('h2')(function (_a) {
    var theme = _a.theme;
    return ({
        margin: theme.spacing(0),
    });
});
var StyledButton = styled(Button)(function () { return ({
    width: '100%',
    paddingLeft: 0,
    '&:hover': {
        background: 'unset',
    },
    '&:focus': {
        boxShadow: 'unset',
    },
    '& .MuiButton-label': {
        justifyContent: 'space-between',
    },
    '& .MuiButton-iconSizeLarge > *:first-child': {
        // removing styles from the dropdown icon
        width: 'unset',
        height: 'unset',
    },
}); });
var StyledHref = styled('a')(function () { return ({
    textDecoration: 'none',
}); });
var StyledInlineSpan = styled('span')(function () { return ({
    display: 'inline-block',
}); });
var StepsLabel = styled('div')(function () { return ({
    display: 'flex',
    alignItems: 'center',
}); });
export var StepHeader = function (props) {
    var anchor = props.anchor, content = props.content, number = props.number, isTopBar = props.isTopBar;
    var showDropDown = isTopBar && number !== 0;
    return showDropDown ? (React.createElement(StepsWithDropdown, __assign({}, props))) : (React.createElement(StyledHref, { href: "#".concat(anchor) },
        React.createElement(StyledInlineSpan, null,
            React.createElement(StyledH2, { id: anchor },
                number > 0 && React.createElement(StepNumber, null, number),
                React.createElement(StepContent, null, content)))));
};
var StepsWithDropdownComponent = function (_a) {
    var anchor = _a.anchor, content = _a.content, _b = _a.steps, steps = _b === void 0 ? [] : _b, number = _a.number;
    var _c = useDropdownMenuState({ baseId: "header-menu-".concat(number) }), triggerProps = _c.triggerProps, menuProps = _c.menuProps;
    return (React.createElement(StyledH2DropDown, { id: anchor },
        React.createElement(StyledButton, __assign({ variant: "link", endIcon: React.createElement(ChevronDownIcon, null) }, triggerProps),
            React.createElement(StepsLabel, null,
                React.createElement(StepNumber, null, number),
                React.createElement(StepContent, null, content))),
        React.createElement(DropdownMenu, __assign({ placement: "left", size: "large" }, menuProps),
            React.createElement(DropdownMenuList, null, steps.map(function (step) { return (React.createElement(DropdownMenuListItem, { key: step.content, title: step.content, href: "#".concat(step.anchor), startIcon: React.createElement(StepNumber, null, step.number) })); })))));
};
var StepsWithDropdown = connectToStores(StepsWithDropdownComponent, [QuickstartStore], function (context) {
    if (!canUseStore(context))
        return {};
    var quickstartStore = context.getStore(QuickstartStore);
    var article = quickstartStore.getCurrentArticle();
    var doc = article && context.getStore(DocumentStore).getDocument(article.url);
    var steps = (doc && doc.meta.steps) || [];
    return {
        steps: steps,
        currentQuickstart: quickstartStore.getCurrentArticle(),
    };
});
